import React from 'react';
import { Fragment, useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next/hooks';

import Button from '../../components/Button/Button';
import CreateGroupForm from '../../components/GroupTalk/EditGroup/CreateGroupForm';
import EditGroupForm from '../../components/GroupTalk/EditGroup/EditGroupForm';
import GroupList from '../../components/GroupTalk/GroupList/GroupList';
import GroupListControll from '../../components/GroupTalk/GroupList/GroupListControll';

import { useStore } from '../../hook-store/store';


import '../VideoTextTalk/VideoTextTalk.css'
import './GroupTalk.css';



const GroupTalkControl = (props) => {
  // console.log('GroupTalk.js-props', props);
  const {
    userId,
    showGroupTalkText,
    showGroupCreation,
    isCreateGroup,
    createGroupHandler,
    createGroupReslut,
    hideGroupCreationHandler,
    getGroupListHandler,
    selectedGroupForEdit,
    upgradeGroupHandler,
    groupUserInfo,
    showGroupTalkTextHandler,
    getGroupInfoHandler, 
    editFavoriteGroupsHandler,
    editFavoriteGroupsResult,
    setShowAuthModal,
    createGroupStartHandler,
    updateGroupStartHandler,
    deleteGroupHandler,
    deleteGroupResult,
    getGroupUserHandler,
    isLoading,
  } = props;


  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    selectedGroupData,
    userSocketId,
    socketState,
    groupList,
  } = store.groupStore;
  const {
    isAuth
  } = store.uiStore;


  let groupControlBody;

  if (socketState && userSocketId && !showGroupTalkText) {
    if (showGroupCreation) {
      groupControlBody = (
        <div>
          {isCreateGroup && (
            <CreateGroupForm 
              userId={userId}
              createGroupHandler={createGroupHandler}
              createGroupReslut={createGroupReslut}
              hideGroupCreationHandler={hideGroupCreationHandler}
              getGroupListHandler={getGroupListHandler}
              isLoading={isLoading}
            />
          )}
          {!isCreateGroup && (
              <EditGroupForm
                userId={userId}
                selectedGroupForEdit={selectedGroupForEdit}
                createGroupReslut={createGroupReslut}
                hideGroupCreationHandler={hideGroupCreationHandler}
                getGroupListHandler={getGroupListHandler}
                upgradeGroupHandler={upgradeGroupHandler}
                isLoading={isLoading}
              />
          )}
        </div>
      )
    }
    else {
      groupControlBody = (
        <div>        
          {isAuth && (  
            <div>
              <GroupListControll
                groupList={groupList}
                groupUserInfo={groupUserInfo}
                showGroupTalkTextHandler={showGroupTalkTextHandler}
                getGroupInfoHandler={getGroupInfoHandler} 
                editFavoriteGroupsHandler={editFavoriteGroupsHandler}
                editFavoriteGroupsResult={editFavoriteGroupsResult}
                setShowAuthModal={setShowAuthModal}
                createGroupStartHandler={createGroupStartHandler}
                isLoading={isLoading}
              />
            </div>
          )}

          <GroupList
            groupList={groupList}
            joinGroupId={selectedGroupData?._id}
            userId={userId}
            updateGroupStartHandler={updateGroupStartHandler}
            showGroupTalkTextHandler={showGroupTalkTextHandler}
            getGroupInfoHandler={getGroupInfoHandler}
            deleteGroupHandler={deleteGroupHandler}
            showGroupTalkText={showGroupTalkText}
            deleteGroupResult={deleteGroupResult}
            isLoading={isLoading}
            getGroupUserHandler={getGroupUserHandler}
          />
        </div>
      );
    }

  }


  return (
    <Fragment>
      <div>
        {groupControlBody}
      </div>
    </Fragment>
  );
};

export default GroupTalkControl;